export * from './base.service';
export * from './auth/auth.service';
export * from './country.service';
export * from './province.service';
export * from './district.service';
export * from './ward.service';
export * from './role.service';
export * from './department.service';
export * from './hub.service';
export * from './user.service';
export * from './hubRoute.service';
export * from './hubRouting.service';
export * from './page.service';
export * from './modulePage.service';
export * from './permission.service';
export * from './areac.service';
export * from './customer.service';


// WEBPACK FOOTER //
// D:/SSW/Project/GSDP/Angular/gsdp_core_angular/src/app/services/index.ts